import { graphql } from 'react-relay';

export default graphql`
  query privatePackageTrackerQuery($packageId: Int!) {
    privatePackageTracker(packageId: $packageId) {
      packageInfo {
        companyName
        packageId
      }
      recipientInfo {
        firstName
        originalPhone
      }
      redispatchInfo {
        trackingCode
        maxPickupTime
        redispatchAgency {
          name
          firstLine
          secondLine
        }
      }
      destinationInfo {
        firstLine
        secondLine
        complement
        classificationType
        instructions
        additionalReceivers
        coordinates {
          lat
          lng
        }
        confirmedByRecipient
      }
      eta
      currentStatus {
        error
        inProgress
        destination
        type
      }
      shipperStatus {
        code
        label
        description
        actionRequired {
          reasonLabel
          reasonDescription
        }
      }
      permissions
      relativeEta
      driverInfo {
        firstName
        photoUrl {
          default
        }
      }
      currentDriverPosition {
        lat
        lng
      }
      shouldConfirmPackageDelivery
      receivedBy
    }
  }
`;
